'use client'

import { LayoutRouterContext } from 'next/dist/shared/lib/app-router-context.shared-runtime'
import { FC, ReactNode, useContext, useRef } from 'react'

type FrozenRouteProps = {
  children: ReactNode
}

const FrozenRoute: FC<FrozenRouteProps> = ({ children }) => {
  const context = useContext(LayoutRouterContext)
  const frozen = useRef(context).current

  return <LayoutRouterContext.Provider value={frozen}>{children}</LayoutRouterContext.Provider>
}

export default FrozenRoute
